export enum AbregelungKopplungsTyp {
    SOLLWERT = 'SOLLWERT',
    TYP_100 = 'TYP_100',
    TYP_60 = 'TYP_60',
    TYP_30 = 'TYP_30',
    TYP_0 = 'TYP_0',
    BLINDLEISTUNG_Q = 'BLINDLEISTUNG_Q',
    WIRKLEISTUNG_P = 'WIRKLEISTUNG_P',
}
